import { render } from "./CommonMessageBox.vue?vue&type=template&id=bb4c0cd8&scoped=true"
import script from "./CommonMessageBox.vue?vue&type=script&lang=js"
export * from "./CommonMessageBox.vue?vue&type=script&lang=js"

import "./CommonMessageBox.vue?vue&type=style&index=0&id=bb4c0cd8&scoped=true&lang=css"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb4c0cd8"]])

export default __exports__